export default __webpack_public_path__ + "static/media/bg-block.8ef2b7ae.jpg";